import { ChangeEventHandler, Fragment } from 'react';

import { STYLES, STYLES_VALUES_TYPE } from './constants';

interface StyleSwitcherProps {
  currentSelection: STYLES_VALUES_TYPE;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

const StyleSwitcher = ({ currentSelection, onChange }: StyleSwitcherProps) => {
  return (
    <Fragment>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          name="mapStyles"
          id="map-dark"
          value={STYLES.dark}
          checked={currentSelection === STYLES.dark}
          onChange={onChange}
        />
        <label className="form-check-label" htmlFor="map-dark">
          Map
        </label>
      </div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input"
          type="radio"
          name="mapStyles"
          id="map-streets"
          value={STYLES.streets}
          checked={currentSelection === STYLES.streets}
          onChange={onChange}
        />
        <label className="form-check-label" htmlFor="map-streets">
          Streets
        </label>
      </div>
    </Fragment>
  );
};

export default StyleSwitcher;
